export default __webpack_public_path__ + "media/Purview.d0e7a326.svg";